import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import OnewayPickupPeriodicHikeTimeDrawer from "components/drawer/OnewayPickupPeriodicHikeTimeDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

const OnewayPickupPeriodicHikeTimeTable = ({
    OnewayPickupPeriodicHikeTime,
    perpage,
    currentPage,
    hideDelete,
    hideEdit,
}) => {
    const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
    const Onewayperiodicdata = OnewayPickupPeriodicHikeTime;
    const parsePgArray = (val) => {
        if (!val) return [];
        return val
            .replace(/[{}"]/g, "")
            .split(",")
            .map(v => v.trim());
    };


    return (
        <>
            <DeleteModal id={serviceId} title={title} />

            <MainDrawer>
                <OnewayPickupPeriodicHikeTimeDrawer id={serviceId} />
            </MainDrawer>

            <TableBody>
                {Onewayperiodicdata
                    ?.slice(0, perpage)
                    .map((data, index) => (
                        <TableRow key={data?.id}>
                            <TableCell className="text-center text-xs">
                                {(currentPage - 1) * perpage + index + 1}
                            </TableCell>

                            <TableCell className="text-center text-xs">
                                {data?.from_city}
                            </TableCell>

                            <TableCell className="text-center text-xs">
                                {data?.to_city}
                            </TableCell>

                            <TableCell className="text-center text-xs px-4 py-3 ">
                                {parsePgArray(data?.start_time).map((t, i) => (
                                    <div className="px-4 py-3" key={i}>{t}</div>
                                ))}
                            </TableCell>

                            <TableCell className="text-center text-xs px-4 py-3 ">
                                {parsePgArray(data?.end_time).map((t, i) => (
                                    <div className="px-4 py-3" key={i}>{t}</div>
                                ))}
                            </TableCell>

                            <TableCell className="text-center text-xs px-4 py-3 ">
                                {data?.vehicles.map((v, i) => (
                                    <div className="px-4 py-3" key={i}>{v.vehicle_type}</div>
                                ))}
                            </TableCell>

                            <TableCell className="text-center text-xs px-4 py-3 ">
                                {data?.vehicles.map((v, i) => (
                                    <div className="px-4 py-3" key={i}>{v.hike}</div>
                                ))}
                            </TableCell>

                            <TableCell className="text-center">
                                <EditDeleteButton
                                    id={data?.id}
                                    handleUpdate={handleUpdate}
                                    handleModalOpen={handleModalOpen}
                                    hideDelete={hideDelete}
                                    hideEdit={hideEdit}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
            </TableBody>


        </>
    );
};

export default OnewayPickupPeriodicHikeTimeTable;
